import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./Bank.css";
import { connect } from "react-redux";
import BankAction from "./BankAction";
import queryString from 'query-string'
import NewHeader from "../../components/NewHeader/NewHeader";
const Bank = (props) => {

    const location = useLocation()
    const [holderName, setHolderName] = useState()
    const [number, setNumber] = useState()
    const [ifscCode, setIfscCode] = useState()
    const [bankName, setBankName] = useState()

    const parsed = queryString?.parse(location?.search);
    

    const accountHolder = (e) =>{
        setHolderName(e.target.value)
    }

    const phoneNumber = (e) => {
        setNumber(e.target.value)
    }

    const ifsc = (e) => {
        setIfscCode(e.target.value)
    } 
    const bank = (e) => {
        setBankName(e.target.value)
    }

    const submitForm = (e) => {
        e.preventDefault();
        console.log("<<<<")
        const data = {
            account_holder_name: holderName,
            account_number: number,
            ifsc_code: ifscCode,
            bank_name: bankName,
        };

        props?.patchFromBankDetails(data,parsed?.id,parsed?.hashid)
        setHolderName('');
        setBankName('');
        setIfscCode('');
        setNumber('');
        
    };
    // 
  return (
    <>
      <NewHeader />
      <div className="BankMain">
        <div className="Bank_border">
          <h1>Enter Bank Details</h1>

          <div className="bank_details">
            <h2></h2>
            <div className="horLinebank" />
          </div>
          <div className="BankAccountMain">
            <div className="BankAcconut">
              <input
                type="text"
                value={holderName}
                placeholder="Account Holder Name"
                required
                onChange={accountHolder}
              />
              <input
                type="number"
                value={number}
                placeholder="Account No"
                required
                onChange={phoneNumber}
              />
            </div>

            <div className="BankAcconut">
              <input
                type="text"
                placeholder="IFSC Code"
                value={ifscCode}
                onChange={ifsc}
                required
            
              />
               <select name="bank" required className="BankAccount44" onChange={bank} value={bankName}>
                <option value="" disabled selected hidden>Bank Name</option>
                <option value="Bank of Baroda">Bank of Baroda</option>
                <option value="Bank of India">Bank of India</option>
               <option value="Bank of Maharashtra">Bank of Maharashtra</option>
               <option value="Canara Bank">Canara Bank</option>
                <option value="Central Bank of India">Central Bank of India</option>
               <option value="Indian Bank">Indian Bank</option>
                <option value="Indian Overseas Bank">Indian Overseas Bank</option>
                <option value="Punjab & Sind Bank">Punjab & Sind Bank</option>
               <option value="Punjab National Bank">Punjab National Bank</option>
               <option value="State Bank of India">State Bank of India</option>
                <option value="UCO Bank">UCO Bank</option>
               <option value="Union Bank of India">Union Bank of India</option>
               <option value="Axis Bank Ltd.">Axis Bank Ltd.</option>
                <option value="Bandhan Bank Ltd.">Bandhan Bank Ltd.</option>
                <option value="CSB Bank Ltd.">CSB Bank Ltd.</option>
               <option value="City Union Bank Ltd.">City Union Bank Ltd.</option>
               <option value="DCB Bank Ltd.">DCB Bank Ltd.</option>
                <option value="Dhanlaxmi Bank Ltd.">Dhanlaxmi Bank Ltd.</option>
               <option value="Federal Bank Ltd.">Federal Bank Ltd.</option>
                <option value="HDFC Bank Ltd">HDFC Bank Ltd</option>
                <option value="ICICI Bank Ltd.">ICICI Bank Ltd.</option>
               <option value="Induslnd Bank Ltd">Induslnd Bank Ltd</option>
               <option value="IDFC First Bank Ltd.">IDFC First Bank Ltd.</option>
                <option value="Jammu & Kashmir Bank Ltd.">Jammu & Kashmir Bank Ltd.</option>
               <option value="Karnataka Bank Ltd.">Karnataka Bank Ltd.</option>
               <option value="Karur Vysya Bank Ltd.">Karur Vysya Bank Ltd.</option>
                <option value="Kotak Mahindra Bank Ltd">Kotak Mahindra Bank Ltd</option>
                <option value="Lakshmi Vilas Bank Ltd.">Lakshmi Vilas Bank Ltd.</option>
               <option value="Nainital Bank Ltd.">Nainital Bank Ltd.</option>
               <option value="RBL Bank Ltd.">RBL Bank Ltd.</option>
                <option value="South Indian Bank Ltd.">South Indian Bank Ltd..</option>
               <option value="Tamilnad Mercantile Bank Ltd.">Tamilnad Mercantile Bank Ltd.</option>
               <option value="YES Bank Ltd..">YES Bank Ltd.</option>
               <option value="IDBI Bank Ltd.">IDBI Bank Ltd..</option>
               
              </select>
            </div>
          </div>
          <div className="bankButton">
            <button type="submit" onClick={submitForm}>Submit</button>
          </div>
        </div>
      </div>
      
    </>
  );
};

const mapStateToProps = (state) => ({
    // Faqs: state.BankReducer.RedoFqa,
    bankDetailResponse: state?.BankReducers?.bankDetailResponse,
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
        patchFromBankDetails: (data,id,hashid) => {
        dispatch(BankAction.patchFromBankDetails(data,id,hashid));
      }
    };
  };
  
  export default {
    component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Bank)),
  };
  

// export default {
//   component: Bank,
// };
